import { FunctionComponent } from 'preact';
import { styled } from 'goober';
import { useUnifiedWidget } from '../providers/UnifiedWidgetProvider';
import { useConfig } from '../providers/ConfigProvider';
import { useEffect } from 'preact/hooks';
import { forwardRef } from 'preact/compat';

type ChatContentContainerProps = {
  open: boolean;
  position: string;
  width: number;
  height: number;
}

const ChatContentContainer = styled('div', forwardRef)(({
  open,
  position,
  width,
  height,
}: ChatContentContainerProps) => ({
  position: "absolute",
  bottom: 0,
  width: `${width}px`,
  height: `${height}px`,
  right: position === "bottom-right" ? '0' : undefined,
  left: position === "bottom-left" ? '0' : undefined,
  borderRadius: "20px",
  overflow: "hidden",
  boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
  visibility: open ? "visible" : "hidden",
  opacity: open ? 1 : 0,
  transform: open ? "" : "translateY(20px) scale(0.95)",
  transition: `opacity 0.1s ease-in-out, transform 0.1s ease-in-out${open ? "" : ", max-width 0s linear 0.2s, max-height 0s linear 0.2s"}`,
  maxWidth: open ? "100%" : "0px",
  maxHeight: open ? `${height}px` : "0px",
  pointerEvents: open ? "auto" : "none",
  background: '#ffffff',
}));

const ChatIframe = styled('iframe', forwardRef)({
  width: "100%",
  height: "100%",
  border: "none",
});

export const ChatContent: FunctionComponent = () => {
  const { open, mode, widgetIframe } = useUnifiedWidget();
  const { config } = useConfig();
  const { position, agentId, width, height } = config;

  const isChatMode = mode === 'chat';
  const showChat = open && isChatMode;

  useEffect(() => {
    if (widgetIframe && showChat) {
      widgetIframe.current?.contentWindow?.focus();
    }
  }, [showChat, widgetIframe]);

  // Always render the iframe when in chat mode - let the iframe handle its own loading state
  // The cookie initialization happens via postMessage from the iframe
  return (
    <ChatContentContainer open={showChat} position={position} width={width} height={height}>
      <ChatIframe ref={widgetIframe} src={`${process.env.WEBSITE_DOMAIN}/chat/${agentId}/`} tabIndex={0}></ChatIframe>
    </ChatContentContainer>
  )
}

